import { useSelector } from "react-redux"
import { getUser } from "~/store"
import UserGroup from "~/components/UserGroup/UserGroup"
import { Link } from "react-router-dom"
import { ExtendedCalendarSpace } from "~/components/CalendarSpacesCard/CalendarSpacesCard"
import "./CalendarEventItem.scss"

const CalendarEventItem = ({ space }: { space: ExtendedCalendarSpace }) => {
  const user = useSelector(getUser)
  const isCurrentSpace = space.name == user?.space_name
  const isBreak = space.current_timer?.break

  return (
    <div
      className={`CalendarEventItem ${
        isBreak ? "CalendarEventItem--break" : "CalendarEventItem--work"
      }`}
    >
      <div className="CalendarEventItem__details">
        <div className="CalendarEventItem__time">
          {space.calendar_event.start_time}

          <UserGroup
            size="xxs"
            align="left"
            guests={space.guests}
            users={space.users}
          />
        </div>
        <div className="CalendarEventItem__title">
          {space.calendar_event.title}
        </div>
      </div>

      <Link to={`/spaces/${space.name}`}>
        {isCurrentSpace ? "Open" : "Join"}
      </Link>
    </div>
  )
}

export default CalendarEventItem
